import { subscriberActiveAPI } from './api';

/*
 * only notified after the Oauth Session Call is Successful 
 * inovked from subscriber.oauthSession()
 */ 
async function subscriberActive () {
    const env = this.env;
    
    const appStore = this.env.appStore;
    const statesStore = this.env.uiStatesStore;

    const apiKey = appStore.widgetSettings.apikey;

    const res = await subscriberActiveAPI({
        apiKey,
        body: {
            oauthSessionId: appStore.oauthSessionId,
            appType: statesStore.selectedCalendar.toLowerCase(),
            email: appStore.oauthEmail,
        },
        widgetId: appStore.widget.id,
        traceId: env.traceId,
        store: this,
    });
    // process res..

    console.log('subscriberActive(): ', res);
    if (Array.isArray(res.data?.data) && res.data?.data.length > 0) {
        // auto subscription post
        const subscriber = res.data.data[0];
        // window.weblog(`API subscriberActive() will subscribed With ID`);
        let email = appStore.oauthEmail;
        // when active, go directly to subscriber (post) then completeSubscription call
        this.subscribeWithId({
            oauthSessionId: appStore.oauthSessionId,
            email: email,
            application: statesStore.selectedCalendar.toLowerCase(),
            id: subscriber.id,
            calendarIds: statesStore.subscribersParams.calendarIds,
        });
    } else {
        // appStore.oauthEmail
        // use oauthEmail on the display
        console.log('subscriberActive(): appStore.oauthEmail: ', appStore.oauthEmail);
        statesStore.subscribersFields.email = appStore.oauthEmail;
        statesStore.initFieldValues();
        appStore.gotoSubscriberForm();
    }
}

export default subscriberActive;